module.exports = __webpack_public_path__ + "img/sj_jiaohua.2460065f.jpg";